<template>
    <b-card no-body>
        <!-- Card image -->
        <img class="card-img-top" :src="currentBook.thumb" alt="Image placeholder">
        Cover CoverPreview
        <!-- Card body -->
        <b-card-body>
            <div class="loader" v-if="loading"></div>
            <b-card-title class="h2 mb-0">Your Art Book #{{ currentBook.id }}</b-card-title>
            <small class="text-muted">
                Publisher Representative: {{ currentBook.editor }}
                <br>
                last change: {{ formatDate(currentBook.updated_at) }}
            </small>
            <b-card-text class="mt-4">
                Click here to continue with your Art Book now. Your next step is:
                <br>
                <strong>{{ currentBook.written_next_step }}</strong>
            </b-card-text>
            <a :href="'#/artist/'+currentBook.id+'/wizard'" class="btn btn-sm btn-dark">Continue Art Book</a>
        </b-card-body>
    </b-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'

export default {
    name: "cover-preview",
    data() {
      return {
        loading: false,
        currentBook: [],
      };
    },
    props: {
        photoBookId: '',
    },
    methods: {
      retrieveBook() {
        this.loading = true;
        this.$api.getPhotoBook(this.photoBookId)
          .then((response) => {
            console.log(response);
            this.currentBook = response.data;
            console.log("CurrentBook:"+this.currentBook);
          })
          .catch((e) => {
            console.log(e);
          }).finally(() => {
            this.loading = false
          });
      },
      formatDate(date) {
        return moment(date).format("Do MMM YYYY")
      },
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount' }),
        bookLoaded: function () {
            return this.currentBook ? true : false;
        }
    },
    mounted() {
     //   this.retrieveBook();
    },
};
</script>
<style></style>